<template>
  <div class="container">
    <div class="monikaoshi">
      <div class="monikaoshi-top">
        <div  class="fanhui" v-if="isShowBack">
           <img src="../../../static/images/other-fanhui.png" @click="back" >
        </div>
        <div class="tab">{{ name }}模拟考试</div>
        <div v-if="false" class="chengjidan" @click="gotopage">成绩单</div>
      </div>
      <div class="monikaoshi-mid">
        <div class="handpic">
          <img src="../../../static/images/other-personicon.png" />
        </div>
        <div class="info">
          <div class="item">
            <div class="name">全国通用</div>
            <div class="des">{{ tips }}</div>
          </div>
          <div class="item">
            <div class="name">考题数量</div>
            <div class="des">{{ count }}题</div>
          </div>
          <div class="item">
            <div class="name">考试时间</div>
            <div class="des">{{ time }}分钟</div>
          </div>
          <div class="item">
            <div class="name">合格标准</div>
            <div class="des">满分100分，{{ score }}分及格</div>
          </div>
          <div class="item">
            <div class="name">出题规则</div>
            <div class="des">按公安部规定出题规则组卷</div>
          </div>
        </div>
        <div class="btn" @click="gotomonikaoshipagepage">
          <button>全真模拟考试</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExamInfo } from "@/api/exam";
export default {
  name: "exam",
  components: {
    // LearnTime
  },
  data() {
    return {
      name: "科目一",
      daojishitime: 0,
      paperid: "",
      kaoshiinfo: "",
      kemuType: 1,
      count: 0,
      score: 0,
      time: 0,
      show: false,
      licence_id: "",
      tips: "",
      isShowBack: false
    };
  },
  mounted() {
    document.getElementsByTagName("html")[0].style = "font-size:625%";
    // if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
  },
  created() {
    if (this.GetRequest('channel') == 'exejH5') {
      this.isShowBack = true
    }
    // let appver = this.GetRequest('appver') ? this.GetRequest('appver') : ''
    // let channel = this.GetRequest('channel') ? this.GetRequest('channel') : ''
    // let os = this.GetRequest('os') ? this.GetRequest('os') : ''
    // let sign = this.checkSing.checkMd5(this.GetRequest('appid')+appver+channel+this.GetRequest('cx')+this.GetRequest('km')+os+this.GetRequest('timestamp') + this.GetRequest('userid'))
    // if( this.GetRequest('appid') && this.GetRequest('cx') && this.GetRequest('km') && this.GetRequest('userid') && this.GetRequest('timestamp') && this.GetRequest('sign') && sign == this.GetRequest('sign')){

    // }else{
    //   this.$router.push({
    //     name: "error",
    //     params: { name: "item", id: 1 }
    //   });
    // }
    console.log(window.location)
    // alert(1111)
    // checkSign({
    //     data_string : window.location.hash
    // },({data})=>{
    //   console.log(11111111111111111)
    //   console.log(data)
    //   if(data.code != 0){
    //     this.$router.push({
    //       name: "error",
    //       params: { name: "item", id: 1 }
    //     });
    //   }
    // })
    document.getElementsByTagName("html")[0].style = "font-size:625%";
    // document.documentElement.style.fontSize = "625%"
    console.log("data:>>>>>2020.12.03.16:43");
    this.licence_id = this.GetRequest('cx')=='xc' ? 2 : this.GetRequest('cx')=='hc' ? 3 :this.GetRequest('cx')=='kc'? 4  :this.GetRequest('cx')=='mtc'?5:6;

    this.$data.kemuType = this.GetRequest('km') == 'kmy'?1 : 4;
    this.$data.name = this.GetRequest('km') == 'kmy'?'科目一' : '科目四';
    this.getMsg();

    if (this.licence_id == 8) {
      this.tips = "客运";
    } else if (this.licence_id == 9) {
      this.tips = "货运";
    } else if (this.licence_id == 11) {
      this.tips = "出租车";
    } else if (this.licence_id == 3) {
      this.tips = "货车A2/B2";
    } else if (this.licence_id == 4) {
      this.tips = "客车A1/A3/B1";
    }else if(this.licence_id == 5){
      this.tips = "摩托车";
    } else {
      this.tips = "小车C1/C2/C3";
    }
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    getUserId(){
      return this.GetRequest('userid')
    },
    GetRequest(value) {
			return this.$route.query[value];
		},
    getMsg() {
		console.log(this.licence_id)
		console.log(this.kemuType)
      getExamInfo({
        licence_id: this.licence_id,
        subject_id: this.kemuType
      }).then(response => {
        // console.log(response);
        var que_list = response.data.question_list;
        this.$data.kaoshiinfo = que_list;
        var list = que_list.split(",");
        this.$data.count = list.length;
        var scorelist = response.data.rule.pass_score.split(".");
        this.$data.score = scorelist[0];
        this.$data.time = response.data.rule.exam_time / 60;
        this.daojishitime = response.data.rule.exam_time * 1;
        this.$data.paperid = response.data.paper_id;
      });
    },
    // back() {
    //   this.$router.push({
    //     name: "home",
    //     params: { name: "item", id: 1 }
    //   });
    // },
    gotopage() {
      this.$router.push({
        name: "chengjidan",
        params: { showType: this.$data.kemuType }
      });
    },
    gotomonikaoshipagepage() {
      if (this.$data.paperid == "") {
        return;
      }
      this.$router.push({
        name: "simulationPaper",
        query: {
					userid: this.GetRequest('userid'),
                    licence_id:this.GetRequest("licence_id"),
					km:this.GetRequest('km'),
					cx:this.GetRequest('cx'),
					appid:this.GetRequest('appid'),
					appver:this.GetRequest('appver'),
					channel:this.GetRequest('channel'),
					os:this.GetRequest('os'),
					timestamp:this.GetRequest('timestamp'),
					sign:this.GetRequest('sign'),
					schoolid:this.GetRequest('schoolid')?this.GetRequest('schoolid') : '',
					coachid:this.GetRequest('coachid')?this.GetRequest('coachid') : '',
          daojishitime: this.daojishitime
				},
        params:{
          showType: this.$data.kemuType,
          kaoshiinfo: this.$data.kaoshiinfo,
          paperid: this.$data.paperid,
          kemuType: this.$data.kemuType,
          passscore: this.score,
          daojishitime: this.daojishitime

        }
      });
    }
  },
  afterDestory() {
    document.documentElement.style.fontSize = "";
  },
  beforeCreate() {
    setTimeout(() => {
      document.getElementsByTagName("html")[0].style = "font-size:625%";
    }, 200);
  }
};
</script>

<style lang="css" scoped>
#app {
  background-color: #fff;
}
</style>
<style lang="scss">
html {
  font-size: 625%;
}
.container {
  .monikaoshi {
    width: 100%;
    height: 3rem;
    margin: 0;
    padding: 0;
    .monikaoshi-top {
      background-size: 100% 100%;
      border-bottom: 1px solid #dcdcdc;
      padding-bottom: 0.11rem;

      .fanhui {
        position: absolute;
        top: 0.2rem;
        left: 0.23rem;
        width: 0.09rem;
        height: 0.18rem;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .tab {
        margin-top: 0.22rem;
        color: #333;
        justify-content: center;
        font-size: 0.18rem;
        width: 60%;
        margin-left: 20%;
        line-height: 0.18rem;
        text-align: center;
      }
      .chengjidan {
        top: 0.2rem;
        position: absolute;
        color: #666666;
        font-size: 0.15rem;
        right: 0.17rem;
      }
    }
    .monikaoshi-mid {
      width: 100%;
      .handpic {
        margin: 0 auto;
        width: 0.72rem;
        height: 0.72rem;
        position: relative;
        margin-top: 0.5rem;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .info {
        width: 70%;
        margin-left: 15%;
        font-size: 0.14rem;
        margin-top: 0.5rem;
        .item {
          display: flex;
          line-height: 0.4rem;
          .des {
            color: #3f3f3f;
            font-weight: bold;
            margin-left: 0.2rem;
          }
        }
      }
      .btn {
        width: 100%;
        margin: 0 auto;
        margin-top: 0.4rem;
        text-align: center;
        button {
          border: 0;
          width: 2.6rem;
          height: 0.45rem;
          background-color: #2c89e8;
          color: #ffffff;
          font-size: 0.16rem;
          border-radius: 0.22rem;
        }
      }
    }
  }
}
</style>
